import React, { useEffect, useState } from 'react';
import { Download, Check } from 'lucide-react';

const standalone = () => window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true;

export const StaffAppInstall = () => {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(standalone());
  const [help, setHelp] = useState(false);

  useEffect(() => {
    if (!document.querySelector('link[rel="manifest"]')) {
      const link = document.createElement('link');
      link.rel = 'manifest';
      link.href = '/staff-app.webmanifest';
      document.head.appendChild(link);
    }
    if ('serviceWorker' in navigator) navigator.serviceWorker.register('/staff-sw.js').catch(() => {});
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); };
    const onInstalled = () => { setInstalled(true); setPrompt(null); };
    window.addEventListener('beforeinstallprompt', onPrompt);
    window.addEventListener('appinstalled', onInstalled);
    return () => { window.removeEventListener('beforeinstallprompt', onPrompt); window.removeEventListener('appinstalled', onInstalled); };
  }, []);

  const install = async () => {
    if (!prompt) { setHelp((v) => !v); return; }
    prompt.prompt();
    const choice = await prompt.userChoice;
    if (choice.outcome === 'accepted') setInstalled(true);
    setPrompt(null);
  };

  if (installed) {
    return <div className="px-4 py-2 flex items-center gap-2 text-xs text-ei-white/50" data-testid="staff-app-installed">
      <Check className="w-3.5 h-3.5 text-ei-gold" /> App installed
    </div>;
  }

  return <div className="px-1">
    <button onClick={install} className="w-full flex items-center gap-3 px-4 py-3 rounded-sm text-ei-white/65 hover:text-ei-white hover:bg-ei-white/5 font-display text-sm font-semibold min-h-[44px]" data-testid="staff-app-install">
      <Download className="w-5 h-5" /> Install staff app
    </button>
    {help && <p className="px-4 pb-3 text-xs leading-relaxed text-ei-white/55" data-testid="staff-app-install-help">
      On iPhone or iPad: tap Share, then “Add to Home Screen”. On desktop Chrome or Edge: use the install icon in the address bar.
    </p>}
  </div>;
};
